<template>
  <div class="flex max-w-[180px] flex-col text-center">
    <UiIcon :icon="icon" />
    <CdnImg
      :src="icon"
      alt=""
      loading="lazy"
      class="mx-auto mb-4 block h-[32px] w-[32px]"
    />
    <div
      class="title text-[14px] font-bold uppercase leading-none text-slate sm:text-[20px]"
      v-html="title"
    />
    <div
      class="mt-2 text-[12px] leading-[normal] text-slate sm:text-[14px] sm:leading-[140%]"
      v-html="description"
    />
  </div>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  icon?: string;
  title?: string;
  description?: string;
}

withDefaults(defineProps<Props>(), {
  icon: '',
  title: '',
  description: '',
});
</script>
